import { Routes } from '@angular/router';

export const ROUTES: Routes = [
  {
    path: 'cambiar-clave',
    title: 'Cambiar Clave',
    data: { title: 'Cambiar Clave' },
    loadComponent: () => import('./pages/cambiar-clave/cambiar-clave.component'),
  },
];
